import { AlkLogger } from '@alk/core';
import { IBackendSessionService } from './backend-session.interface';
import { injectable } from 'inversify';

@injectable()
export class BackendSessionMock implements IBackendSessionService {

    synchronize(): void {
        AlkLogger.info('[BackendSessionMock#synchronize]');
    }
}
